import { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';

import { IwFormRef } from '@components/form';

import { useLazyGetOrderByIdQuery } from '@/features/slice/order';
import { useCreateSalesReturnMutation } from '@/features/slice/sales-return';
import { CreateSalesReturnForm } from '@/modules/sales-return/create-sales-return/schema';
import { toastError } from '@/utils';

export const useCreateSalesReturn = () => {
    const [orderId, setOrderId] = useState('');

    const formRef = useRef<IwFormRef<CreateSalesReturnForm>>(null);

    const [
        getOrderById,
        {
            isLoading: isOrderLoading,
            isError: isOrderError,
            isFetching: isOrderFetching,
            error: orderError,
            data: orderData,
        },
    ] = useLazyGetOrderByIdQuery();

    const [createSalesReturn, { isLoading: isCreateSalesReturnLoading }] =
        useCreateSalesReturnMutation();

    // const { reset, setValue } = useFormContext<CreateSalesReturnForm>();

    const submitCreateSalesReturn = async (data: CreateSalesReturnForm) => {
        const selectedItems = data.items.filter(
            (item) => item.returnQuantity > 0 && item.isSelected,
        );

        try {
            const payload = {
                order_id: orderId,
                items: selectedItems.map((item) => ({
                    id: item.itemId,
                    quantity: item.returnQuantity,
                    price: item.price,
                    rate: item.price,
                })),
            };
            await createSalesReturn(payload).unwrap();

            if (formRef.current) {
                formRef.current.reset();
            }

            toast.success('Sales return created successfully.');
        } catch (error) {
            toastError(error, 'useCreateSalesReturn:submitCreateSalesReturn');
        }
    };

    useEffect(() => {
        if (orderId) {
            getOrderById(orderId);
        }
    }, [orderId]);

    return {
        orderId,
        setOrderId,
        orderData,
        orderError,
        isOrderLoading,
        isOrderError,
        isOrderFetching,
        getOrderById,
        isLoading: isOrderLoading || isOrderFetching,
        createSalesReturn,
        isCreateSalesReturnLoading,
        submitCreateSalesReturn,
        formRef,
    };
};
